import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { ENVIRONMENT } from "../../environments/environment";
import { EnergyConsult } from "../classes/flow/request/EnergyConsult";
import { RequestState, RequestStates } from "../classes/flow/request/RequestStates";
import { Coach } from "../classes/flow/session/impl/Coach";
import { EpfService } from "./epf.service";
import { convertDate } from "../helpers/convertDate";

@Injectable({
  providedIn: "root",
})
export class CoachEnergyConsultService {
  private epf = inject(EpfService);
  private httpClient = inject(HttpClient);

  public async AcceptEnergyConsult(energyConsult: EnergyConsult, coach: Coach, states: RequestState[]) {
    try {
      const payload = energyConsult.duplicate();
      if (payload.state.name === RequestStates.NEW) payload.setState(RequestStates.PICKED, states);
      payload.coach = coach;

      const result = await this.epf.updateEnergyConsult(payload);
      return result;
    } catch (error) {
      console.error(error);
      return energyConsult;
    }
  }

  public async getAttachmentList(energyConsult: EnergyConsult) {
    return energyConsult.attachments;
  }

  public async getSendReportDate(energyConsult: EnergyConsult) {
    return energyConsult.lastSendDate;
  }

  public async setSendReportDate(energyConsult: EnergyConsult) {
    try {
      const payload = energyConsult.duplicate();
      const date = new Date();
      date.setHours(date.getHours() + date.getTimezoneOffset() / -60);
      payload.lastSendDate = convertDate(date);
      const result = await this.epf.updateEnergyConsult(payload);
      return result;
    } catch (error) {
      console.error(error);
      return energyConsult;
    }
  }

  /**
   * Rejects the given energyConsult
   * @param energyConsult The energyConsult to be rejected
   */
  public async rejectEnergyConsult(energyConsult: EnergyConsult, sendMail: boolean, reason: string, requestStates: RequestState[]) {
    try {
      const payload = energyConsult.duplicate();
      payload.setState(RequestStates.PENDING_REJECT, requestStates);
      payload.rejectReason = reason;
      payload.sendResidentMail = sendMail;
      const result = await this.epf.updateEnergyConsult(payload);
      return result;
    } catch (error) {
      console.error(error);
      return energyConsult;
    }
  }

  public async saveDate(energyConsult: EnergyConsult, date: Date, requestStates: RequestState[]) {
    try {
      const payload = energyConsult.duplicate();
      payload.setState(RequestStates.DATE, requestStates);
      payload.appointmentDate = convertDate(date);
      const result = await this.epf.updateEnergyConsult(payload);
      return result;
    } catch (error) {
      console.error(error);
      return energyConsult;
    }
  }

  /**
   * Executes post
   * JWT token gets auto added in msal interceptor depending on endpoint
   * check MSAL.ts to add endpoints
   * @param endpoint string to specify endpoint after url
   * @param data data in the body to be send
   * @param options additional headers you want to add
   * @returns succesful result or Error type
   */
  public async postRequest(endpoint: string, data: unknown, options: any = {}): Promise<any> {
    try {
      const res = await firstValueFrom(this.httpClient.post(ENVIRONMENT.API_URL + endpoint, data, options));
      return res;
    } catch {
      return new Error();
    }
  }
}
